export enum COLOR_TYPES {
    PRIMARY = 'primario',
    SECUNDARY = 'secundario'
}